import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach((table) => this.#formatTable(table));
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    // Wrap so genuinely wide tables can scroll instead of breaking the layout.
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    // For comparison tables (first row is all header cells), stamp every body
    // cell with its column header so the CSS can stack the table into labeled
    // cards on mobile instead of cramming N prose columns into a phone's width.
    const rows = Array.from(table.rows);
    const headerRow = rows[0];
    if (!headerRow || !Array.from(headerRow.cells).every((cell) => cell.tagName === 'TH')) {
      return;
    }
    const labels = Array.from(headerRow.cells, (cell) => cell.textContent.trim());
    for (const row of rows.slice(1)) {
      Array.from(row.cells).forEach((cell, index) => {
        if (index > 0 && labels[index]) cell.setAttribute('data-label', labels[index]);
      });
    }
    table.classList.add('rte-table--labeled');
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
